import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconReset = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.09375 5.875C0.710938 5.875 0.4375 5.60156 0.4375 5.21875V1.28125C0.4375 0.925781 0.710938 0.625 1.09375 0.625C1.44922 0.625 1.75 0.925781 1.75 1.28125V3.49609L2.29688 2.83984C3.41797 1.5 5.08594 0.625 7 0.625C10.3633 0.625 13.125 3.38672 13.125 6.75C13.125 10.1406 10.3633 12.875 7 12.875C5.60547 12.875 4.34766 12.4375 3.30859 11.6719C3.03516 11.4531 2.95312 11.043 3.17188 10.7422C3.39062 10.4414 3.80078 10.3867 4.10156 10.6055C4.89453 11.207 5.90625 11.5625 7 11.5625C9.65234 11.5625 11.8125 9.42969 11.8125 6.75C11.8125 4.09766 9.65234 1.9375 7 1.9375C5.49609 1.9375 4.18359 2.62109 3.28125 3.6875L2.54297 4.5625H5.03125C5.38672 4.5625 5.6875 4.86328 5.6875 5.21875C5.6875 5.60156 5.38672 5.875 5.03125 5.875H1.09375Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgIconReset);
export { ForwardRef as ReactComponent };
